export enum ApiEndPoints {
    AuthSignup = '/v1/auth/signup',// this endipoit path for live.
    AuthUsername = '/v1/auth/check-username',// this endipoit path for live.
    AuthConfirm = '/v1/auth/confirm-account',// this endipoit path for live.
    AuthSignin = '/v1/auth/signin',// this endipoit path for live.
    AuthConfirmEmail = '/v1/auth/verify-email',// this endipoit path for live.
    AuthVerifyaccount = '/v1/auth/verification-account',// this endipoit path for live.
    CreateNewPass = '/v1/auth/forget-password',// this endipoit path for live.
    ContactUs = '/v1/user/contact-us',// this endipoit path for live.
    AddTOCart = '/v1/cart/add-to-cart',// this endipoit path for live.
    GetAllCart = '/v1/cart/',// this endipoit path for live.
    RemoveCardItem = '/v1/cart/remove-from-cart', // ✅ Add this
    SearchAmazonItems = '/v1/amazon/search-amazon',
    FetchAmazonItem = '/v1/amazon/fetch-amazon',
    CreateProduct = '/v1/product',
    AdminProducts = '/v1/product/admin/all',
    BuynowCart = '/v1/user/submit-user-info', // ✅ Add this
    UpdateProfile = '/v1/user/upload-profile-photo',
    GetProfilePhoto = '/v1/user/profile-photo',
    DeleteProfilePhoto = '/v1/user/delete-profile-photo',
    UpdateUserProfile = '/v1/user/update-user-profile',
    GetUserProfile = '/v1/user/get-user-profile',
}